import * as React from 'react';
import {
    LeadershipProfileList,
    type ProfileFlowConfig,
} from 'features/DigitalMarketing/pages/EditWebsiteContent/LeadershipProfiles/LeadershipProfileList';

const facultyProfileFlowConfig: ProfileFlowConfig = {
    title: 'Faculty Profiles',
    description: 'Showcase the people behind your Institution success',
    listSubPath: 'faculty-profiles',
    createSubPath: 'faculty-profiles/create',
    editSubPath: 'faculty-profiles/edit',
    emptyMessage: 'No faculty profiles found',
    nameColumnLabel: 'Faculty Name',
    breadcrumbLabel: 'Faculty Profiles',
    showRoleColumn: false,
    api: {
        resource: 'faculty' as const,
        list: '/master/listFaculty',
        delete: '/master/deleteFaculty',
        publish: '/master/publishFaculty',
        indexParam: 'staff_id',
    },
};

export function FacultyProfileList() {
    return <LeadershipProfileList config={facultyProfileFlowConfig} />;
}
